module.exports = __webpack_public_path__ + "a96b9a7c6c8962917b1ad5f2bd200696.svg";